import React from 'react';

import './footer.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopyright } from '@fortawesome/free-regular-svg-icons';

const Footer = () => {
  return (
    <div className="giswnauce__footer" style={{ textAlign: 'center' }}>
        <p>Copyright <FontAwesomeIcon icon={ faCopyright }/> 2026 Uniwersytet Warmińsko-Mazurski w Olsztynie & Jakub Jabłoński. All rights reserved.</p>
        <p>Strona przygotowana we współpracy z Politechniką Gdańską, z wykorzystaniem rozwiązań technicznych opracowanych na potrzeby Konferencji GIS w Nauce 2024.</p>
    </div>
  )
}

export default Footer